app.controller('DataApiOverviewController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    const dataApiID = $scope.data_api_id ? $scope.data_api_id : ($state.$current && $state.$current.data ? $state.$current.data.data_api_id : null);

    const dataApiService = $rootScope.service.data_api;

    $scope.data_api_model = dataApiService.factory.getModel({data_api_id: dataApiID});

    $scope.data_api_model.requireOverviewPostList();

    $scope.category_slug = null

    $scope.categorySelected = function () {
        const sref = $scope.data_api_model.category_sref;
        if ($scope.category_slug && sref) {
            $state.go(sref, {category_slug: $scope.category_slug});
        }
    }

}]);